t = require('views/internal/teacup-with-helpers')('power_ups_about_card_aging')

module.exports = ->
  t.format 'cards-will-visibly-age-as-time-passes-without-any-activity-regular-mode-will-cause-old-cards-to-become-progressively-more-transparent-pirate-mode-will-cause-old-cards-to-crack-and-tear-like-an-old-treasure-map-once-cards-have-new-activity-on-them-their-age-counter-is-reset-and-they-appear-new-again-age-thresholds-are-1-2-and-4-weeks'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_ups_about_card_aging.coffee